export class DownloadBlobFileUtils {
  public static downloadBlob(blob: Blob, filename: string): void {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }

  public static generateFilenameWithDate(baseName: string, extension: string): string {
    const date = new Date().toISOString().split('T')[0];
    return `${baseName}-${date}.${extension}`;
  }
}
